var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Editor',{attrs:{"init":_vm.configuration,"value":_vm.content},on:{"onSetContent":_vm.onContentReady,"onChange":_vm.onContentReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }